module.exports = __webpack_public_path__ + "0b822a86cc67bd499e52de4e520e8561.pdf";